import { useEffect } from "react";

export const useIdleCallback = (callback: () => void, timeoutMs: number = 1): void => {
  useEffect(() => {
    if (typeof requestIdleCallback === "function") {
      const idleCallbackId = requestIdleCallback(callback);
      return () => cancelIdleCallback(idleCallbackId);
    }

    const timeoutId = setTimeout(callback, timeoutMs);
    return () => clearTimeout(timeoutId);
  }, [callback, timeoutMs]);
};
